import { useSettings } from './providers/SettingsProvider';
export const defaultTexts = {
    menuSpeedTitle: 'Speed',
    menuQualityTitle: 'Quality',
    normalSpeed: 'Normal',
    buttonTooltip: 'Settings',
    autoQualityTitle: 'Auto',
    menuSubtitlesTitle: 'Subtitles',
    subtitlesOffLabel: 'Off',
    ccButtonTooltip: 'CC',
};
export const useTexts = () => {
    const { config: { texts }, } = useSettings();
    return { ...defaultTexts, ...texts };
};
//# sourceMappingURL=useTexts.js.map